<template>
  <header class="masthead">
            <div class="container">                
                <div class="masthead-subheading">Bienvenido </div>
                <div class="masthead-heading text-uppercase">Gestión legal integral y confiable</div>
                <a class="btn btn-success btn-xl text-uppercase shadow" href="#services">Asesoría Legal</a>
            </div>
        </header>
</template>
<script>
export default {
  name: 'Header',
};
</script>

<style scoped>
/* Add any specific styles for the Header here if needed */
</style>
